import { prova } from "./prova";
import { questao } from "./questao";
import { redacao } from "./redacao";

export const conteudo = [...prova, ...questao, ...redacao];



// WEBPACK FOOTER //
// ./src/routes/prova/conteudo/index.js